import React, { useState, useEffect } from 'react';
import {
  Topbar,
  Alert,
  LoginAlert,
  GameAlert,
  Overlay,
} from '@components';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  RootContainer,
  Title,
  Top,
  Image,
  Loader,
  PlayerListContainer,
  PlayerBox,
  Number,
  DataContainer,
  NameAndAmountContainer,
  PlayerName,
  Amount,
  PhoneNumberContainer,
  PhoneNumber,
  Container,
  Text,
  BoldText,
  ButtonWrapper,
} from './TopWinners.style';
import { Button, Spin } from 'antd';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { api, Status } from '@api';
import {
  BURMESE_LANGUAGE_CODE_LK,
  CHINESE_LANGUAGE_CODE_LK,
} from '@constants';
import { useDispatch, useSelector } from 'react-redux';
import { getFormattedNumber } from '@utils';
import { useTranslation } from 'react-i18next';
import {
  setAlert,
  setPrevRoute,
} from '@redux/game/gameSlice';
import { useGame } from '@hooks';
import { localStorage } from "@utils";
import { saveUser } from "@redux/auth/authSlice";

const TopWinners = () => {
  const dispatch = useDispatch();
  const { pathname, state: game } = useLocation();
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { child_game_id } = useParams();
  const lang = useSelector(state => state.app.userPreferedLanguage);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [child_game, setChildGame] = useState({});
  const { launchGame, exitGame } = useGame();
  const { gameExitStatus } = useSelector((state) => state.game);

  useEffect(() => {
    getWinners();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (gameExitStatus === Status.SUCCESS) {
      api
        .getWinners({
          child_game_id,
        })
        .then(({ user }) => {
          updateUserInApp(user);
        })
        .catch(() => { });
    }

    // eslint-disable-next-line
  }, [gameExitStatus]);

  const getWinners = () => {
    setLoading(true);
    api
      .getWinners({
        child_game_id,
      })
      .then(({ winners, child_game, user }) => {
        setLoading(false);
        const _game = parseData([{ ...child_game }])[0];
        setChildGame(_game);
        setData(winners);
        updateUserInApp(user);
      })
      .catch(() => { });
  }

  const handleGameClicked = () => {
    if (!game.active) {
      dispatch(
        setAlert({
          title: t("maintain.maintainTitle"),
          description: <>{t("maintain.maintainSubtitle1")} <br />  {t("maintain.maintainSubtitle2")}</>,
          open: true,
          maintain: true,
        })
      );
      return;
    }

    /**
     * Save pathname to redux, 
     * to use from ingame page for going back
     **/
    dispatch(setPrevRoute(pathname));
    /**
     * Launch game
     */
    launchGame(game);

  }

  /**
 * Update user in app
 * Redux & Localstorage
 */
  const updateUserInApp = (user) => {
    if (user) {
      // Save user to redux
      dispatch(saveUser(user));
      // Set user to localstorage
      localStorage.setUser(user);

      // if current user is ingame, exit
      user.is_in_game && exitGame();
    }
  };

  /**
   * get game names and icons 
   * based on current app language
   */
  const parseData = (games) => {
    return games.map(item => {
      return {
        ...item,
        icon: lang === CHINESE_LANGUAGE_CODE_LK
          ? item.icon_ch
          : lang === BURMESE_LANGUAGE_CODE_LK
            ? item.icon_mm
            : item.icon_en,
        name: lang === CHINESE_LANGUAGE_CODE_LK
          ? item.name_ch
          : lang === BURMESE_LANGUAGE_CODE_LK
            ? item.name_mm
            : item.name_en,
      }
    });
  }

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.GAMES}`);
  }

  const renderTop = () => (
    <Top>
      <Image src={child_game.icon} />
      <Title>
        {t("topWinner.topWinnerSubtitle")}
      </Title>
      <div>
        <Text>{`${t("topWinner.totalWinning")}: `}</Text>
        <BoldText>{getFormattedNumber(game.winning_amount)}</BoldText>
      </div>
    </Top>
  );

  if (!game) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />
  }

  return (
    <>
      <Topbar
        title={child_game.name}
        goBack={goBack}
      />
      <RootContainer>
        {loading && (
          <Loader>
            <Spin />
          </Loader>
        )}
        {!loading &&
          <Container>
            {renderTop()}
            <PlayerListContainer>
              {data.map((item, index) => (
                <PlayerBox key={index} first={index === 0 ? 'true' : 'false'}>
                  <Number>
                    {index + 1}.
                  </Number>
                  <DataContainer>
                    <NameAndAmountContainer>
                      <PlayerName> {item.name} </PlayerName>
                    </NameAndAmountContainer>
                    <PhoneNumberContainer>
                      <PhoneNumber> {item.phone} </PhoneNumber>
                    </PhoneNumberContainer>
                  </DataContainer>
                  <Amount>{`${getFormattedNumber(item.amount)}`}</Amount>
                </PlayerBox>
              ))}
            </PlayerListContainer>
            <ButtonWrapper>
              <Button type='primary' onClick={handleGameClicked}>
                {t("topWinner.playNow")}
              </Button>
            </ButtonWrapper>
          </Container>
        }
      </RootContainer>
      <Alert />
      <LoginAlert />
      <Overlay />
      <GameAlert />
    </>
  );
}

export default TopWinners;